/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
// console.log("Hello World! (from create-block-bloque-estudio-menu block)");
/* eslint-enable no-console */

$body = null;
document.addEventListener("DOMContentLoaded", function(event) {
    activarMenuEstudio();
    $body = document.querySelector('body');
});



function activarMenuEstudio(){
    $selector = document.querySelector('.bloque-estudio-menu .selector');
    if($selector){
        $selector.addEventListener('click', function(){
            this.closest('.bloque-estudio-menu').classList.toggle('open');
        });
    }

    window.addEventListener('scroll', function(event){ 
        if(this.window.scrollY>0){
            if(!$body.classList.contains('scrolled')){
                $body.classList.add('scrolled');
            }
        }else{
            if($body.classList.contains('scrolled')){
                $body.classList.remove('scrolled');
            }
        }
    })

    $enlaces = document.querySelectorAll('.bloque-estudio-menu li');
    if($enlaces){
        for (let $i = 0; $i < $enlaces.length; $i++) {
            const $enlace = $enlaces[$i];
            $enlace.addEventListener('click', function(){
                if(this.attributes.rel){
                    $bloque = $enlace.closest('.bloque-estudio-menu');
                    $bloque.classList.remove('open');
                    // $bloque.querySelector('.current').classList.remove('current');
                    // this.classList.add('current');
    
                    $id = this.attributes.rel.value;
                    if($id){
                        $objetivo = document.querySelector('#'+$id);
                        if($objetivo){
                            $objetivo.scrollIntoView();
                        }
                    }
    
                }
            })
        }
    }

    
}


